<template>
    <card class="card">
        <div class="card-body">
            <h2 class="pt-0 mt-0">
                <i class="fas fa-file-invoice text-primary"></i> {{$t('request.titleedit')}}
            </h2>
            <hr />
            <div>
                <form @submit.prevent id="userEdit">
                    <div class="row mt-4">
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                :label="$t('request.code')"
                                name="code"
                                placeholder
                                v-model="form.request_code"
                                :disabled="!isRequestAdmin"
                            ></fg-input>
                        </div>
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                :label="$t('request.repairid')"
                                name="repair_id"
                                placeholder
                                v-model="form.repair_id"
                                :disabled="!isRequestAdmin"
                            ></fg-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-md-6">
                            <label>{{$t('request.asf')}}</label>
                            <multiselect
                                v-model="form.asf"
                                :options="asfs"
                                :custom-label="asfLabel"
                                :placeholder="$t('reques.text.selectone')"
                                label="name"
                                track-by="id"
                                disabled
                            ></multiselect>
                        </div>
                        <div class="col-md-6">
                            <label for="request_status">
                                {{ $t('request.status') }}
                                <template v-if="!canChangeRequestStatus && saved_status">
                                    :
                                    <strong>{{ currentStatusLabel }}</strong>
                                </template>
                            </label>
                            <select
                                id="request_status"
                                class="form-control request-status-select"
                                v-model="form.status"
                                :disabled="isStatusSelectReadonly"
                            >
                                <option
                                    v-if="showEmptyStatusOption"
                                    value
                                >{{ $t('request.text.select') }}</option>
                                <option
                                    v-for="opt in requestStatusOptions"
                                    :key="opt.value"
                                    :value="opt.value"
                                    :disabled="isStatusOptionDisabled(opt.value)"
                                    :class="statusOptionClass(opt.value)"
                                >{{ $t(opt.labelKey) }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="row mt-4" v-if="form.status == 'completed'">
                        <div class="col-md-6">
                            <fg-input
                                type="text"
                                :label="$t('request.invoicenumber')"
                                name="invoice_number"
                                placeholder
                                v-model="form.invoice_number"
                            ></fg-input>
                        </div>
                    </div>
                    <div class="row mt-4">
                        <div class="col-md-12">
                            <ShoppingCart
                                :showButtons="false"
                                :Options="false"
                                :showRequestButton="false"
                            />
                            <button
                                v-if="isRequestAdmin && form.status == 'in transit'"
                                class="btn btn-lg btn-primary px-4"
                                v-b-modal.shoppingCart
                            >{{$t('request.changeparts')}}</button>
                        </div>
                    </div>
                    <div class="row mt-2 mb-2">
                        <div class="col-md-12">
                            <label for>{{$t('request.notes')}}</label>
                            <textarea
                                class="form-control"
                                v-model="form.note"
                                name="note"
                                cols="30"
                                rows="5"
                            ></textarea>
                        </div>
                    </div>
                    <div class="text-left">
                        <p-button type="primary" @click.native.prevent="update">{{$t('request.button.save')}}</p-button>
                    </div>
                    <div class="clearfix"></div>
                </form>
            </div>
        </div>
        <b-modal id="shoppingCart" ref="shoppingCart" size="xl" hide-footer title="Request Parts">
            <RequestParts :showAsfSelection="false" :showButtons="true" :showReqButton="false"></RequestParts>
        </b-modal>
    </card>
</template>
<script>
import { mapState } from "vuex";
import ShoppingCart from "@/pages/parts/ShoppingCart.vue";
import RequestParts from "@/pages/parts/RequestParts.vue";

const REQUEST_STATUS_OPTIONS = [
  { value: "new", labelKey: "request.option.new" },
  { value: "in_analysis", labelKey: "request.option.in_analysis" },
  { value: "analysis_completed", labelKey: "request.option.analysis_completed" },
  { value: "in transit", labelKey: "request.option.intransit" },
  { value: "completed", labelKey: "request.option.completed" },
  { value: "canceled", labelKey: "request.option.canceled" }
];

export default {
  components: {
    ShoppingCart,
    RequestParts
  },
  data() {
    return {
      cannabalization: false,
      saved_status: "",
      saved_request_code: "",
      saved_repair_id: "",
      requestStatusOptions: REQUEST_STATUS_OPTIONS
    };
  },
  computed: {
    ...mapState("requests", {
      request: "request"
    }),
    ...mapState("cart", {
      cart: "all",
      inCart: "inCart"
    }),
    ...mapState("asfs", {
      asfs: "all"
    }),
    form() {
      return this.request;
    },
    isRequestAdmin() {
      return this.$store.getters["auth/isInRoles"]("admin");
    },
    isAsfAdmin() {
      return this.$store.getters["auth/isInRoles"]("asf-admin");
    },
    canChangeRequestStatus() {
      return (
        this.isRequestAdmin ||
        (this.isAsfAdmin && this.saved_status === "in transit")
      );
    },
    isStatusSelectReadonly() {
      return (
        this.saved_status === "completed" || !this.canChangeRequestStatus
      );
    },
    showEmptyStatusOption() {
      return this.isRequestAdmin && this.canChangeRequestStatus;
    },
    currentStatusLabel() {
      const opt = REQUEST_STATUS_OPTIONS.find(
        o => o.value === this.saved_status
      );
      return opt ? this.$t(opt.labelKey) : this.saved_status;
    }
  },
  created() {
    this.$store.dispatch("requests/get", this.$route.params.id).then(resp => {
      let arr = [];
      this.request.items.forEach(item => {
        arr.push({
          name: item.part.name,
          part_id: item.part_id,
          sku: item.part.sku,
          quantity: item.quantity,
          in_warranty: item.in_warranty,
          inventory_type_id: item.inventory_type_id,
          from_stock: 0,
          unit_price: item.part.price,
          price: !item.in_warranty ? item.part.price * item.quantity : 0
        });
      });
      this.$store.commit("cart/setCart", arr);
      this.$store.dispatch("cart/getAllParts", "requests");
      if (this.isRequestAdmin) {
        this.$store.dispatch("asfs/getAllAsfs");
      }
      this.saved_status = this.request.status;
      this.saved_request_code = this.request.request_code;
      this.saved_repair_id = this.request.repair_id;
    });
  },
  methods: {
    statusIsDisabled() {
      if (
        this.request.status_history === null ||
        !this.request.status_history.includes("analysis_completed")
      ) {
        return true;
      }
      return false;
    },
    canSelectStatus(value) {
      if (!value) {
        return this.showEmptyStatusOption;
      }
      if (!this.canChangeRequestStatus || this.isStatusSelectReadonly) {
        return false;
      }
      if (this.isRequestAdmin) {
        if (
          ["in transit", "completed", "canceled"].includes(value) &&
          this.statusIsDisabled()
        ) {
          return false;
        }
        return true;
      }
      if (this.isAsfAdmin && this.saved_status === "in transit") {
        return value === "completed";
      }
      return false;
    },
    isStatusOptionDisabled(value) {
      if (!value) {
        return !this.showEmptyStatusOption;
      }
      return !this.canSelectStatus(value);
    },
    statusOptionClass(value) {
      return value === this.saved_status
        ? "request-status-option--current"
        : null;
    },
    asfLabel({ name, vat }) {
      return `${name} — ${vat}`;
    },
    tog_cann() {
      this.cannabalization = !this.cannabalization;
    },
    update() {
      if (
        this.form.status !== this.saved_status &&
        !this.canSelectStatus(this.form.status)
      ) {
        this.$notify({
          type: "danger",
          horizontalAlign: "center",
          message: this.$t("request.message.statusReadonly")
        });
        return;
      }
      if (!this.isRequestAdmin) {
        this.form.request_code = this.saved_request_code;
        this.form.repair_id = this.saved_repair_id;
      }
      this.form.asf_id = this.form.asf.id;
      this.form.items = this.inCart;
      this.$store
        .dispatch("requests/edit", this.form)
        .then(response => {
          this.request = this.form;
          this.saved_status = this.form.status;
          this.saved_request_code = this.form.request_code;
          this.saved_repair_id = this.form.repair_id;
          this.$notify({
            type: "success",
            message: this.$t("request.message.successupdate")
          });
        })
        .catch(error => {
          let msg = "";
          if (error.response.data) {
            msg = error.response.data.errors[0].detail;
          } else {
            msg = error.response.message;
          }
          this.$notify({
            type: "danger",
            horizontalAlign: "center",
            message: msg
          });
        });
    }
  }
};
</script>
<style scoped>
.request-status-select option.request-status-option--current {
  font-weight: bold;
}
</style>
